import React from 'react'
import Modal from './../../../../UIElements/Modal'
import styles from './../../styles/LockedModal.module.scss'
import { getAwsAssets } from '@src/utils'
import { useDispatch } from 'react-redux'
import { buyNowDoubtBuddyModalAction } from '@src/layout/store/actions'

const LockedModal = ({handleModal,handleItemClicked}) => {
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(buyNowDoubtBuddyModalAction(false))
    }
  return (
    <div className={styles.LockedModal}>Included with the course
      <Modal handleClose={handleClose}>
        <div className={styles.maincontainer}>
            <div className={styles.topcontainer}>
                <img 
                    src={getAwsAssets("doubtBody-lock.svg", "Overview")}
                    height={63}
                    width={63}
                />
                <p className={styles.topheading}>DoubtMate is Locked</p>
                <p className={styles.topSubHeading}>Buy the course to unlock your DoubtMate and resolve your doubts 24x7</p>
            </div>
            <hr className={styles.breaker}/>
            <div className={styles.middlecontainer}>
                <p className={styles.topheading}>How it works?</p>
                <div className={styles.worklist}>
                    <div className={styles.lists}>
                        <img src={getAwsAssets("phone-camera.svg", "Overview")} width={48} height={48}/>
                        <p className={styles.listDesc}>Click a picture of your doubt</p>
                    </div>
                    <div className={styles.lists}>
                        <img src={getAwsAssets("doubtBudy-paper.svg", "Overview")} width={48} height={48}/>
                        <p className={styles.listDesc}>Crop & Post</p>
                    </div>
                    <div className={styles.lists}>
                        <img src={getAwsAssets("fast-time.svg", "Overview")} width={48} height={48}/>
                        <p className={styles.listDesc}>Get Superfast solution with explanation in 60 seconds</p>
                    </div>
                </div>
            </div>
            <div className={styles.bottomcontainer}>
                <button className={styles.buyButton} onClick={()=> handleItemClicked()}>Buy Now</button>
                <button className={styles.gotItButton} onClick={handleClose}>Ok, got it.</button>
            </div>
        </div>
      </Modal>
    </div>
  )
}

export default LockedModal
